import {
  IWidgetFormStep,
  WidgetDisposalStepLogic
} from 'common/schema/widget/disposal/WidgetDisposalStepLogic';
import { memoize } from 'lodash';
import { useRequestCompileContext } from './RequestCompileContext';

const memoizedGetSteps = memoize(WidgetDisposalStepLogic.getSteps);

/**
 * Ottiene informazioni in merito agli Step di compilazione della domanda.
 * Si basa sul concetto di {@link WidgetDisposal} configurato lato backend.
 */
export function useRequestSteps() {
  const compileContext = useRequestCompileContext();
  const steps = memoizedGetSteps(compileContext.procedure);
  const currentStep = steps[compileContext.currentStep];

  return {
    steps,
    current: currentStep,
    currentIndex: compileContext.currentStep,
    previous: steps[compileContext.currentStep - 1] as
      | IWidgetFormStep
      | undefined,
    next: steps[compileContext.currentStep + 1] as IWidgetFormStep | undefined,
    isLast: compileContext.currentStep === steps.length - 1,
    isFirst: compileContext.currentStep === 0,
    setCurrentStep: compileContext.setCurrentStep
  };
}

export type IRequestSteps = ReturnType<typeof useRequestSteps>;
